export const PXTextImageStack = (function() {
	'use strict';

	var $blocks;

	function init() {
		$blocks = $('.pxblock--text-image-stack');
		if(!$blocks.length > 0) return null;
		// events();
		
	}

	function events() {}

	return {
		init: init
	};
})();
